<template>
  <div
    id="product-selection"
    class="section-wrapper flex flex-col items-center space-y-10 py-12 min-h-screen justify-center pb-20"
  >
    <!-- center the contents of each product block -->
    <div class="flex flex-col items-center">
      <h1 class="text-2xl font-semibold mb-4">ProAct 360&trade;</h1>
      <p class="text-base text-center mb-6">
        A complete perspective. Perfected for progress.
      </p>
      <button
        :disabled="!hasProact360Access"
        @click="onProductSelect('proact360')"
        class="w-64 inline-flex items-center justify-center px-6 py-3 rounded"
        :class="{
          'cursor-not-allowed border-2 border-grey-darkLight bg-grey-lightest text-grey-dark': !hasProact360Access,
          'btn-success cursor-pointer': hasProact360Access
        }"
      >
        Proceed to ProAct360&trade; matrix calculator
      </button>
    </div>

    <hr class="w-64 border-t border-gray-300 my-6" />

    <div class="flex flex-col items-center">
      <h1 class="text-2xl font-semibold mb-4">Ronozyme ProAct</h1>
      <p class="text-base text-center mb-6">
        Looking for the Ronozyme ProAct calculator?
      </p>
      <button
        :disabled="!hasProactAccess"
        @click="onProductSelect('proact')"
        class="w-64 inline-flex items-center justify-center px-6 py-3 rounded"
        :class="{
          'cursor-not-allowed border-2 border-grey-darkLight bg-grey-lightest text-grey-dark': !hasProactAccess,
          'btn-success cursor-pointer': hasProactAccess
        }"
      >
        Proceed to Ronozyme ProAct matrix calculator
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ProductSelection',

  mounted() {
    this.$store.commit('setNavigation');
  },

  methods: {
    ...mapActions({
      selectProduct: 'productSelect/onProductSelection'
    }),

    onProductSelect(product) {
      this.selectProduct({ selectedProduct: product })
          .then(() => {
            this.errors = [];
            this.$router.push({ name: 'home' });
          })
          .catch((err) => {
            console.error(err.data);
            this.errors = err.data.errors;
          });
    }
  },

  computed: {
    ...mapGetters({
      hasProactAccess: 'auth/hasProactAccess',
      hasProact360Access: 'auth/hasProact360Access'
    })
  }
};
</script>

<style scoped>

</style>
